import React from 'react';

import s from './planV2.module.scss';

import imgItem_1 from './img/item_1.png';
import imgItem_2 from './img/item_2.png';
import imgItem_3 from './img/item_3.png';
import imgItem_4 from './img/item_4.png';
import { useT } from '@hooks';

function PlanV2() {
	const { T } = useT();
	return (
		<div className={s.planV2}>
			<h2 className={s.planTitle}>{T('personalized_plan')}</h2>
			<ul className={s.planList}>
				<li className={s.planListItem}>
					<div className={s.planListItem_imgItem_container}>
						<img className={s.planListItem_imgItem} src={imgItem_1} alt='icon' />
					</div>
					<div className={s.planListItem_text}>
						<div className={s.planListItem_text_top}>{T('mobile_app')}</div>
						<div className={s.planListItem_text_bottom}>{T('mobile_app_tailor')}</div>
					</div>
				</li>
				<li className={s.planListItem}>
					<div className={s.planListItem_imgItem_container}>
						<img className={s.planListItem_imgItem} src={imgItem_2} alt='icon' />
					</div>
					<div className={s.planListItem_text}>
						<div className={s.planListItem_text_top}>{T('daily_programs_for')}</div>
						<div className={s.planListItem_text_bottom}>{T('daily_programs_for_2')}</div>
					</div>
				</li>
				<li className={s.planListItem}>
					<div className={s.planListItem_imgItem_container}>
						<img className={s.planListItem_imgItem} src={imgItem_3} alt='icon' />
					</div>
					<div className={s.planListItem_text}>
						<div className={s.planListItem_text_top}>{T('audio_trainers')}</div>
						<div className={s.planListItem_text_bottom}>{T('audio_guided')}</div>
					</div>
				</li>
				<li className={s.planListItem}>
					<div className={s.planListItem_imgItem_container}>
						<img className={s.planListItem_imgItem} src={imgItem_4} alt='icon' />
					</div>
					<div className={s.planListItem_text}>
						<div className={s.planListItem_text_top}>{T('comprehensive_stats')}</div>
						<div className={s.planListItem_text_bottom}>{T('comprehensive_track')}</div>
					</div>
				</li>
			</ul>
		</div>
	);
}

export default PlanV2;
